import { Button } from "@mui/material";
import PropTypes from "prop-types";

export default function AppButton({
  text,
  icon,
  onClick,
  variant = "text",
  className = "",
  disabled = false,
  iconClassName = "",
  style,
  buttonStyle,
  href,
  fullWidth,
  sx,
  dataTestId,
  endIcon,
  endImage,
}) {
  return (
    <Button
      style={{ textTransform: 'none',...buttonStyle }}
      onClick={onClick}
      href={href}
      variant={variant}
      disabled={disabled}
      fullWidth={fullWidth}
      className={`flex items-center gap-2 mr-2 ${className}`}      
      startIcon={
        icon ? (
          <img
            src={icon}
            alt="icon"
            className={`w-6 h-6 ${iconClassName}`}
            style={style}
          />
        ) : null
      }
      endIcon={
        endImage ? (
          <img
            src={endImage}
            alt="icon"
            className={`w-6 h-6 ${iconClassName}`}
            style={style}
          />
        ) : (
          endIcon
        )
      }
      disableRipple
      sx={{sx}}
      data-testid={dataTestId}
    >
      {text}
    </Button>
  );
}

// Prop types validation
AppButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,  // Assuming the icon is a URL (string)
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),  // MUI variants
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconClassName: PropTypes.string,
  style:PropTypes.string,
  buttonStyle:PropTypes.string,
  href:PropTypes.string.string,
  fullWidth:PropTypes.bool,
  sx: PropTypes.object,
  dataTestId:PropTypes.string,
  endIcon:PropTypes.node,
  endImage:PropTypes.string,
};
